<template>
  <a-modal
    :visible="fileModal"
    :centered="true"
    :closable="false"
    :width="1100"
    :footer="null"
    @cancel="closeModal"
  >
    <template #title>
      <div class="ant-row-flex-space-between ant-row-flex">
        <div style="height: 30px; line-height: 30px; display: flex"></div>
        <div style="height: 30px; line-height: 30px">
          <my-icon
            @click="closeModal"
            type="icon-icon_close"
            style="color: #545757; font-size: 24px; margin-top: 3px"
          ></my-icon>
        </div>
      </div>
    </template>
    <div style="width: 100%; text-align: center">
      <video
        v-if="fileState === 0"
        :src="fileUrl"
        :autoplay="true"
        :page-gesture="true"
        controls
        style="max-height: 500px"
      ></video>
      <audio
        v-if="fileState === 1"
        :src="fileUrl"
        controls
        autoplay
        loop
        muted
        style="width: 100%"
      ></audio>
      <iframe
        v-if="fileState === 2 || fileState === 3"
        :src="$officeLink + 'op/view.aspx?src=' + fileUrl"
        width="100%"
        height="500"
        frameborder="0"
      >
      </iframe>
      <div style="overflow:auto;max-height: 700px;">
        <img
          v-if="fileState === 4"
          :src="fileUrl"
          style="max-width: 70%"
        />
      </div>
      <iframe
        v-if="fileState === 5"
        :src="fileUrl"
        width="100%"
        height="500"
        frameborder="0"
      > </iframe>
      <div
        v-if="fileState === 6"
        v-html="htmlText"
        style="
            width: 100%;
            white-space: pre-wrap;
            max-height: 500px;
            overflow-y: auto;
            padding: 20px;
            text-align: left;
          "
      ></div>
    </div>
  </a-modal>
</template>
<script>
export default {
  data() {
    return {
      fileState: 10,
      htmlText: '',
      fileModal: false,
    }
  },
  methods: {
    closeModal() {
      this.fileState = 10
      this.fileModal = false
      this.$emit("closeModal")
    },
    // 开启弹框只需要用ref调用previewClick
    async previewClick(url, { type, fileState, fileName }) {
      console.log(url, type, fileState, fileName)
      this.fileUrl = url
      this.fileState = fileState
      this.type = type
      if (type) {
        this.type = type.toLowerCase()
      }
      // 不传图片类型，根据文件名判断
      if (type === undefined && fileName !== undefined) {
        this.type = fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase()
      }
      if (this.type === 'html') {
        window.open(url, '_blank')
        return
      }
      const officeArr = ['docx', 'doc', 'pptx', 'ppt', 'xlsx', 'xls']
      if (this.type === 'mp4') {
        this.fileState = 0
      } else if (this.type === 'mp3') {
        this.fileState = 1
      } else if (this.type === 'jpg' || this.type === 'png' || this.type === 'jpeg') {
        this.fileState = 4
      } else if (this.type === 'pdf') {
        this.fileState = 5
      } else if (this.type === 'txt') {
        this.fileState = 6
        this.loadTxtOrHtml(url)
      } else if (officeArr.includes(this.type)) {
        this.fileState = 2
      }
      // await this.loadTxtOrHtml(url)
      // this.fileUrl = "https://ziyitong-ocr.oss-cn-hangzhou.aliyuncs.com/%E6%95%99%E8%82%B2%E8%AF%B4%E8%AF%BE.pdf"
      this.fileModal = true
    },
    loadTxtOrHtml(url, num) {
      var xh = window.Event ? new XMLHttpRequest() : new window.ActiveXObject('Microsoft.XMLHTTP')
      xh.open('GET', url, true)

      //这里改变编码格式，如果是txt格式，则为gb2312，如果是html格式，则为utf-8
      let code = num == '3' ? 'gb2312' : 'utf-8'
      if (window.Event) xh.overrideMimeType('text/xml;charset=' + code)
      xh.onreadystatechange = () => {
        if (xh.readyState != 4) return
        var v
        v = window.Event ? xh.responseText : window.gb2utf8(xh.responseBody)
        //txt文件内容
        this.htmlText = v.replace(' ', '&nbsp')
      }
      xh.send(null)
    },
  },
}
</script>
<style lang='less' scoped>
</style>
